import Result from 'models/Result';
import Base from 'models/Base';

import {
  RESULT_ASYNC_START,
  RESULT_ASYNC_SUCCESS,
  RESULT_ASYNC_FAIL,
} from 'actions/result';

const initialState = new Base({
  loading: false,
  errorMessage: '',
  data: new Result(),
});

const actionsMap = {
  [RESULT_ASYNC_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: '',
    });
  },
  [RESULT_ASYNC_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new Result(action.data),
    });
  },
  [RESULT_ASYNC_FAIL]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
      data: new Result(),
    });
  },
};

export default function result(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
